import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'; // Cambiado a MatDialog sin legacy
import { MatPaginator, PageEvent } from '@angular/material/paginator'; // Cambiado a MatPaginator sin legacy
import { MatTableDataSource } from '@angular/material/table'; // Cambiado a MatTableDataSource sin legacy
import { PrintEncuestaComponent } from 'src/app/modales/print-encuesta/print-encuesta.component';
import { EncuestasServiceService } from 'src/app/services/encuestas-service.service';

const ELEMENT_DATA: any[] = [];

@Component({
    selector: 'app-encuestas-mannager',
    templateUrl: './encuestas-mannager.component.html',
    styleUrls: ['./encuestas-mannager.component.scss'],
    standalone: false
})
export class EncuestasMannagerComponent implements OnInit {
  length = 0;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  index = 0;

  // MatPaginator Output
  pageEvent: PageEvent;
  isLoading = false;
  formulario = new FormGroup({
    busqueda: new FormControl("", [])
  });
  displayedColumns: string[] = ['position', 'publico', 'nombre', 'editar', 'imprimir', 'eliminar'];
  dataSource = new MatTableDataSource<any>(ELEMENT_DATA);

  constructor(private dialog: MatDialog, private encuestasService: EncuestasServiceService) { }

  ngOnInit(): void {
    this.buscar(0);
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;

  buscar(index: number): void { // Especificado tipo number
    this.isLoading = true;
    this.encuestasService.getInventario(this.formulario.controls["busqueda"].value, this.pageSize, index).subscribe((result: any) => { // Cambiado a tipo any
      console.info(result);
      this.isLoading = false;
      if (result.code == 200) {
        this.dataSource = new MatTableDataSource<any>(result.datos);
        this.length = result.size;
      } else {
        this.dataSource = new MatTableDataSource<any>([]);
        this.length = 0;
      }
    }, (error: any) => { // Cambiado a tipo any
      this.length = 0;
      this.isLoading = false;
      console.info(error);
      this.dataSource = new MatTableDataSource<any>([]);
    });
  }

  buscador(index: number): void { // Especificado tipo number
    if (index == 0) {
      this.paginator.pageIndex = 0;
    }
    this.buscar(index);
  }

  page(event: PageEvent): void { // Especificado tipo PageEvent
    this.pageSize = event.pageSize;
    this.index = event.pageIndex * event.pageSize;
    this.buscar(this.index);
  }

  imprimir(id: number): void { // Especificado tipo number
    this.dialog.open(PrintEncuestaComponent, { data: { id: id } });
  }
}
